import '../styles/CompanyDetails.css';

interface CompanyDetailsProps {
  theme?: 'light' | 'dark';
}

const CompanyDetails: React.FC<CompanyDetailsProps> = ({ theme }) => {
    return (
        <>
            <div className={`d-flex flex-wrap ${theme === 'dark' ? 'company-details-dark' : 'company-details-light'}`}>
                <p><i>E-Mail:</i> <a href="mailto:Owner@smartmesh-electrics.co.uk">Owner@smartmesh-electrics.co.uk</a></p>
            </div>
        </>
    );
}

export default CompanyDetails;
